// extracted by mini-css-extract-plugin
export var askAiIcon = "_r2-9";
export var container = "_r2-0";
export var groupSeparator = "_r2-a";
export var highlight = "_r2-4";
export var resultIcon = "_r2-5";
export var resultItem = "_r2-7";
export var resultSubtitle = "_r2-3";
export var resultTitle = "_r2-2";
export var resultsList = "_r2-1";
export var searchGroup = "_r2-6";
export var selected = "_r2-8";